<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    class=" fill-current"
  >
    <path
      d="M383 233c-3-5-9-9-15-9h-64V16c0-9-7-16-16-16h-64c-9 0-16 7-16 16v208h-64a16 16 0 00-12 27l112 128a16 16 0 0024 0l112-128c4-5 5-12 3-18z"
    />
    <path
      d="M432 352v96H80v-96H16v128c0 18 14 32 32 32h416c18 0 32-14 32-32V352h-64z"
    />
  </svg>
</template>
